<div class="lg">
    <div class="lg-brand" aria-hidden="true">
        <svg class="lg-waves" viewBox="0 0 600 800" preserveAspectRatio="xMidYMid slice"><path d="M-40 620 C 120 520, 240 700, 380 600 S 620 480, 700 560" /><path d="M-40 680 C 140 580, 260 760, 400 660 S 640 540, 720 620" /><path d="M-40 160 C 100 80, 260 220, 420 120 S 620 40, 700 90" /></svg>
        <div class="lg-brand-in">
            <img class="lg-logo" src="/assets/images/logo-guai.png" alt="Guai Insurtech">
            <h1>Gestor de operaciones</h1>
            <p>Expedientes, citas, proveedores y facturación en un solo lugar.</p>
        </div>
        <div class="lg-brand-foot">© GUAI Insurtech</div>
    </div>

    <div class="lg-side">
        <div class="lg-card">
            <div class="lg-mini"><img src="/assets/images/logo-guai-black.png" alt="Guai Insurtech"></div>
            <h2>Inicia sesión</h2>
            <p class="lg-sub">Accede con tu usuario de GUAI.</p>

            <form autocomplete="off" novalidate>
                <label class="lg-field">
                    <span>Correo electrónico</span>
                    <span class="lg-box">
                        <i class="pi pi-user"></i>
                        <input placeholder="nombre@empresa.com" type="text" [(ngModel)]="formData.username" [ngModelOptions]="{standalone: true}"/>
                    </span>
                </label>
                <label class="lg-field">
                    <span>Contraseña</span>
                    <span class="lg-box">
                        <i class="pi pi-lock"></i>
                        <p-password placeholder="••••••••" [feedback]="false" [toggleMask]="true" [(ngModel)]="formData.password" [ngModelOptions]="{standalone: true}" (keyup.enter)="login()"/>
                    </span>
                </label>
            </form>

            <div class="lg-row">
                <!--<p-checkbox [binary]="true" label="Recordar datos" [(ngModel)]="formData.remember"/>-->
                <a class="lg-link" (click)="recover()">¿Has olvidado tu contraseña?</a>
            </div>

            <p-button label="Iniciar sesión" (click)="login()" styleClass="lg-btn"></p-button>

            <div class="lg-lang">
                <div id="google_translate_element"></div>
                <img src="https://www.gstatic.com/images/branding/googlelogo/1x/googlelogo_color_42x16dp.png" width="37px" height="14px" alt="Google Traductor de Google">
            </div>
        </div>

        <div class="lg-version">{{ versionLabel }}</div>
    </div>
</div>
